<template>
    <div class="d-flex">
        <side-nav></side-nav>
        <div class="content">
            <div class="row">
                <div class="col-xs-12">
                    <router-view :key="$route.fullPath" />
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    // @ is an alias to /src
    //import Axios from 'axios';
    //import router from 'vue-router';
    import sideNav from '../components/sideNav/Index'
    import { mapFields } from 'vuex-map-fields';
    import { mapState } from 'vuex';
    import commonMessages from '../../locales';
    import localMessages from '../locales';

    export default {
        name: 'appRolesList',
        created() {

        },
        data() {
            return {
                  
            }
        },
        computed: {
            ...mapState(['isTreeListVisible'])
        },
        methods: {
        },
        mounted() {

        },
        components: {
            sideNav
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>